import { Component } from '@angular/core';
import { ShowComponent } from 'src/app/common/component/show.component';

import { Lead } from '../leads.model';

@Component({
	selector: 'app-leads-show',
	templateUrl: './leads-show.component.html',
	styleUrls: ['./leads-show.component.css'],
})
export class LeadsShowComponent extends ShowComponent {
	protected itemsBeforeDataLoad = 5;
	protected parentComponent = 'leads';
	setStatus: string = null;
	data: Lead = {
		id: this.route.snapshot.params['id'],
		author: null,
		owner: null,
		firstName: null,
		lastName: null,
		type: null,
		source: null,
		city: null,
		country: null,
		email1: null,
		email2: null,
		gender: null,
		pesel: null,
		phone1: null,
		phone2: null,
		street: null,
		tags: null,
		zip_code: null,
		status: null,
		note: null,
		externalId: null,
		externalType: null,
	};
	tasks: Array<any> = [];
	status: string = null;
	statuses: Array<any> = [];
	users: Array<any> = [];
	types: Array<any> = [];
	sources: Array<any> = [];
	resigns: Array<any> = [];
	statusesInfo = false;
	showAskReason = false;
	resignReason: string;
	private questionsetStatusSubscription;
	private questionsetOwnerSubscription;

	protected loadBefore(): void {
		this.api.get('/leadsStatuses/', (result, error) => {
			this.statuses = result.data;
			this.loadData();
		});
		this.api.get('/users/', (result, error) => {
			this.users = result.data;
			this.loadData();
		});
		this.api.get('/leadsTypes/', (result, error) => {
			this.types = result.data;
			this.loadData();
		});
		this.api.get('/leadsSources/', (result, error) => {
			this.sources = result.data;
			this.loadData();
		});
		this.api.get('/leadsResigns/', (result, error) => {
			this.resigns = result.data;
			this.loadData();
		});
	}

	protected convertData(data): Array<Lead> {
		data.source = parseInt(data.source);
		this.status = data.status;
		return data;
	}

	setStatusAsk(status: string): void {
		if (status == '3') {
			this.showAskReason = true;
			return;
		}
		this.question.ask('Czy chcesz zmienić status?', 'setStatusAsk');
		this.questionsetStatusSubscription = this.question.status.subscribe((result) => {
			if (result.dialogId != 'setStatusAsk') {
				return;
			}
			if (!result.result) {
				return;
			}
			this.api.post('/leads/' + this.data.id + '/setStatus/', { status: status }, (result, error) => {
				if (error) {
					return;
				}
				this.loadData();
			});
		});
	}

	resignSave(): void {
		this.api.post(
			'/leads/' + this.data.id + '/setResign/',
			{ status: 3, reason: this.resignReason },
			(result, error) => {
				if (error) {
					return;
				}
				this.infobox.success('Zapisane');
			},
		);
	}

	setOwnerAsk(): void {
		this.question.ask('Czy przypisać do Ciebie?', 'setOwnerAsk');
		this.questionsetOwnerSubscription = this.question.status.subscribe((result) => {
			if (result.dialogId != 'setOwnerAsk') {
				return;
			}
			if (!result.result) {
				return;
			}
			this.api.post('/leads/' + this.data.id + '/setOwner/', { owner: null }, (result, error) => {
				if (error) {
					return;
				}
				this.loadData();
			});
		});
	}

	noteSave(): void {
		this.api.post('/leads/' + this.data.id + '/setNote/', { note: this.data.note }, (result, error) => {
			if (error) {
				return;
			}
			this.infobox.success('Zapisane');
		});
	}

	tagChanged(): void {
		this.loadData();
	}
}
